import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill/src/quill-editor.component';
import { AlertService } from '../../Services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from '../../Services/event.service';
import { AuthService } from '../../Services/auth.service';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';

//https://github.com/KillerCodeMonkey/ngx-quill

@Component({
  selector: 'app-evenement-form',
  template: require('./evenement-form.component.html'),
  styles: [require('./evenement-form.component.css')]
})
export class EvenementFormComponent implements OnInit {
  @ViewChild('editor') editor: QuillEditorComponent;
  @ViewChild('quilviewer') quilviewer: QuillEditorComponent;

  readonly evenementType = 2;

  editor_modules: any = {}
  evenement: any = {}
  viewer: boolean = false;
  viewer_theme: string = 'bubble'

  selectedDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private auth: AuthService) {
    this.editor_modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],
        // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean'],                                         // remove formatting button

        ['link', 'image', 'video']                         // link and image, video
      ]
    }
    route.params.subscribe(p => {
      if (p['id']) {
        this.evenement.id = +p['id'];
        this.viewer = true;
      }
      else {
        this.evenement.id = 0;
        this.viewer = false;
      }

    });

  }

  ngOnInit() {
    if (this.evenement.id > 0) {
      this.eventService.getEventById(this.evenement.id).subscribe(res => {
        this.evenement = res;
        // console.log(this.evenement);
        
        var d = new Date(this.evenement.beginDate);
          this.selectedDate = {
            jsdate: d,
            date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
          };      
      });
    }
  }

  submit() {
    // console.log("Submit pressed");
    // console.log(this.editor.editorElem.innerHTML);
    // console.log(this.editor.editorElem.innerText);
    // this.evenement.content = this.editor.editorElem.innerHTML;
    this.evenement.beginDate = String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day),
    this.evenement.eventTypeId = this.evenementType;
    this.evenement.endDate = this.evenement.beginDate;
    // console.log("submit Evenement: ")
    // console.log(this.evenement);
    if (this.evenement.id) {
      this.eventService.update(this.evenement).subscribe(x => {
        if (x == 200)
          this.alertService.success("Evenement bewaard", true)
        else
          this.alertService.error("Probleem met bewaren", true)
      });

      // this.router.navigate(['/eventlist',this.evenementType]);
    }
    else {
      this.eventService.create(this.evenement).subscribe(res => {
        // console.log(res)
        if (res['status'] == 200) {
          this.alertService.success("Evenement aangemaakt.")
          this.evenement.id = res['value'].id;
        }
        else {
          this.alertService.error("Er is iets mis gegaan.")
        }
      });
    }
  }


  deleteEvenement() {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit evenement wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.eventService.delete(this.evenement).subscribe(x => {
            // console.log("Delete")
            this.router.navigate(['/evenementList', this.evenementType]);
          });
        }
      });
  }

  changeEditMode() {
    // console.log("change Edit");
    this.viewer = !this.viewer;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/evenement-form/evenement-form.component.ts